export default __webpack_public_path__ + "static/media/tenant.80564f4b.svg";